export const makeApiUrlAuthentication = (): string => {
  return '/auth/signin';
};

export const makeApiUrlSignInViaImpersonate = (): string => {
  return '/auth/signin/impersonate';
};

export const makeApiUrlMenu = (): string => {
  return '/auth/menu';
};

export const makeApiUrlLastProductVersions = (): string => {
  return '/common-utils/last-product-version';
};

export const makeApiUrlDirectorNotifications = (): string => {
  return '/web/director/notifications';
};

export const makeApiUrlTable = (): string => {
  return '/tables';
};

export const makeApiUrlOrganizationsUser = (): string => {
  return '/organizations/list-user-associated';
};

export const makeApiUrlCoursesUser = (): string => {
  return '/courses/list-user-associated';
};

export const makeApiUrlCurricularUnitsUser = (): string => {
  return '/curricular-unit/list-user-associated';
};

export const makeApiUrlSemestersUser = (): string => {
  return '/semesters/list-user-associated';
};

export const makeApiUrlGroupsUser = (): string => {
  return '/groups/list-user-associated';
};

export const makeApiUrlCHMetrics = (): string => {
  return '/dashboard/get-workload-metrics';
};

export const makeApiUrlCompletedAndMissedActivitiesCount = (): string => {
  return '/dashboard/completed-and-missed-activities-count';
};

export const makeApiUrlActivitiesInProgressCount = (): string => {
  return '/dashboard/activities-in-progress-count';
};

export const makeApiUrlUsersMetrics = (): string => {
  return '/dashboard/get-users-online';
};

export const makeApiUrlActivitiesByPlace = (): string => {
  return '/dashboard/get-resume-activities-by-place';
};

export const makeApiUrlActivitiesByTask = (): string => {
  return '/dashboard/get-resume-activities-by-task';
};

export const makeApiUrlActivitiesByStudent = (): string => {
  return '/dashboard/get-resume-activities-by-student';
};

export const makeApiUrlActivitiesByGroup = (): string => {
  return '/dashboard/get-resume-activities-by-group';
};

export const makeApiUrlAllActivitiesByStatus = (): string => {
  return '/dashboard/get-activities-by-status';
};

export const makeApiUrlMapActivitiesMarkers = (): string => {
  return '/dashboard/get-geolocations-activities-points';
};

export const makeApiUrlMapInternshipMarkers = (): string => {
  return '/dashboard/get-geolocations-internship-points';
};

export const makeApiUrlMapActivityDetails = (): string => {
  return '/dashboard/get-geolocation-activity-details';
};

export const makeApiUrlProfessionals = (): string => {
  return '/users/professionals';
};

export const makeApiUrlUnlinkProfessional = (): string => {
  return '/professionals/unlike';
};

const academicManagementReportsUrl =
  '/web/director/reports/academic-management';

export const makeApiUrlAcademicManagementGroups = (): string =>
  `${academicManagementReportsUrl}/groups`;

export const makeApiUrlAcademicManagementGroupsExportExcel = (): string =>
  `${academicManagementReportsUrl}/groups/export/excel`;

export const makeApiUrlAcademicManagementTasks = (): string =>
  `${academicManagementReportsUrl}/tasks`;

export const makeApiUrlAcademicManagementTasksExportExcel = (): string =>
  `${academicManagementReportsUrl}/tasks/export/excel`;

export const makeApiUrlAcademicManagementInternshipLocations = (): string =>
  `${academicManagementReportsUrl}/internship-locations`;

export const makeApiUrlAcademicManagementInternshipLocationsExportExcel =
  (): string =>
    `${academicManagementReportsUrl}/internship-locations/export/excel`;

export const makeApiUrlAcademicManagementProfessionals = (): string =>
  `${academicManagementReportsUrl}/professionals`;

export const makeApiUrlAcademicManagementProfessionalsExportExcel =
  (): string => `${academicManagementReportsUrl}/professionals/export/excel`;

export const makeApiUrlTeamReport = (): string => {
  return '/web/director/reports/professionals/team';
};

export const makeApiUrlConsolidatedActivitiesByStudent = (): string => {
  return '/reports/activities/consolidated-by-student';
};

export const makeApiUrlPerformanceSpreadsheetReport = (): string => {
  return '/reports/professionals/performance-sheet-report';
};

export const makeApiUrlSummaryProfile = (): string => {
  return '/dashboard/get-profile-summary';
};
export const makeApiUrlProfessionalsWorkJourney = (): string => {
  return '/web/director/reports/professionals/work-journey/';
};

export const makeApiUrlProfessionalsWorkJourneyExportPdf = (): string => {
  return '/web/director/reports/professionals/work-journey/export/pdf';
};

export const makeApiUrlProfessionalsWorkJourneyExportExcel = (): string => {
  return '/web/director/reports/professionals/work-journey/export/excel';
};

export const makeApiUrlStudentsWorkloadAchievement = (): string => {
  return '/web/director/reports/students/workload-achievement';
};

export const makeApiUrlStudentsWorkloadAchievementExportPdf = (): string => {
  return '/web/director/reports/students/workload-achievement/export/pdf';
};

export const makeApiUrlStudentsWorkloadAchievementExportExcel = (): string => {
  return '/web/director/reports/students/workload-achievement/export/excel';
};

export const makeApiUrlStudentsFrequencyReport = (): string => {
  return '/reports/students/get-students-attendance/export';
};

export const makeApiUrlProfessionalsSelectOptions = (): string => {
  return 'users/professionals/select-options';
};

export const makeApiUrlStudentsIndividualWorkloadReport = (): string => {
  return '/reports/students/individual-workload';
};

export const makeApiUrlActivitiesQuantityPerStudentExportPdf = (): string => {
  return '/web/director/reports/activities/daily-count/export/pdf';
};

export const makeApiUrlActivitiesQuantityPerStudentExportExcel = (): string => {
  return '/web/director/reports/activities/daily-count/export/excel';
};

export const makeApiUrlProfessionalReport = (): string => {
  return '/reports/professionals/performance-report';
};

export const makeApiUrlReportsAnalyticalActivitiesByStudent = (): string => {
  return '/reports/activities/get-activities-per-students';
};

export const makeApiUrlStudents = (): string => {
  return '/students';
};

export const makeApiUrlStudentsSelectOptions = (): string => {
  return '/students/select-options';
};

export const makeApiUrlActivityReportInternshipLocation = (): string => {
  return '/reports/activities/analytical-internship-location';
};

export const makeApiUrlActivitiesAnalyticalPerTask = (): string => {
  return '/reports/activities/task-analytics';
};

export const makeApiUrlInternshipLocation = (): string => {
  return '/internship-locations/list-user-associated';
};

export const makeApiUrlStudentReportDailyWorkload = (): string => {
  return 'reports/students/daily-workload';
};

export const makeApiUrlActivityByStatus = (): string => {
  return '/activities';
};

export const makeApiUrlGroupList = (): string => {
  return '/groups';
};

export const makeApiUrlArchivedGroups = (): string => {
  return '/groups/archived';
};

export const makeApiUrlAddPersonToGroup = (): string => {
  return '/groups/configuration/add-person';
};

export const makeApiUrlRemovePersonFromGroup = (): string => {
  return '/groups/configuration/remove-person';
};

export const makeApiUrlAddPlaceToGroup = (): string => {
  return '/groups/configuration/add-place';
};

export const makeApiUrlRemovePlaceFromGroup = (): string => {
  return '/groups/configuration/remove-place';
};

export const makeApiUrlImportPersonsFromAnotherGroup = (): string => {
  return '/groups/configuration/import-persons';
};

export const makeApiUrlImportPlacesFromAnotherGroup = (): string => {
  return '/groups/configuration/import-places';
};

export const makeApiUrlPersonsFromGroup = (): string => {
  return '/groups/persons';
};

export const makeApiUrlPlacesFromGroup = (): string => {
  return '/groups/places';
};

export const makeApiUrlActivitiesSummarizedByStudent = (): string => {
  return 'reports/activities/summarized-by-student';
};

export const makeApiUrlSummaryReportByGroup = (): string => {
  return '/reports/activities/summarized-by-group';
};

export const makeApiUrlActivitiesSummaryByTask = (): string => {
  return '/reports/activities/summarized-by-task';
};

export const makeApiUrlSummaryReportByInternshipLocation = (): string => {
  return '/reports/activities/summarized-by-place';
};

export const makeApiUrlUsers = (): string => {
  return '/users';
};

export const makeProfilesAssociated = (): string => {
  return '/person';
};

export const makeApiUrlActivitiesAnalyticalPerGroup = (): string => {
  return '/reports/activities/analytical-by-group';
};

export const makeApiUrlStudentsWithoutRegisteringApp = (): string => {
  return '/students/no-app-register';
};

export const makeApiUrlStudentsNoAppUsage = (): string => {
  return '/students/no-app-usage';
};

export const makeApiUrlValidatedByProfessionals = (): string => {
  return '/activities/validated-by-professionals';
};

export const makeApiUrlRejectedByProfessionals = (): string => {
  return '/activities/rejected-by-professionals';
};

export const makeApiUrlAppRegisteredStudentsPerGroup = (): string => {
  return '/reports/students/registered-app-by-group';
};

export const makeApiUrlNumberStudentsPerProfessionalInField = (): string => {
  return '/web/director/reports/professionals/students-in-field';
};

export const makeApiUrlExportNumberStudentsPerProfessionalInField =
  (): string => {
    return '/web/director/reports/professionals/students-in-field/export/excel';
  };

export const makeApiUrlCheckProfessionalExists = (): string => {
  return '/professionals/find-by-cpf';
};

export const makeApiUrlProfessionalsManager = (): string => {
  return '/professionals';
};

export const makeApiUrlProfessionalOverview = (): string => {
  return '/professionals/overview';
};

export const makeApiUrlCities = (): string => {
  return '/cities';
};

export const makeExternalApiUrlZipCode = (): string => {
  return 'https://viacep.com.br/ws';
};

export const makeApiUrlProfession = (): string => {
  return '/professions';
};

export const makeApiUrlAuthSignOut = (): string => {
  return '/auth/sign-out';
};

export const makeApiUrlUsersOnline = (): string => {
  return '/users/online';
};

export const makeApiUrlUsersOnlineMaps = (): string => {
  return '/users/online/distribution';
};

export const makeApiUrlPushNotification = (): string => {
  return '/notifications/push-notification/filtered';
};

export const makeApiUrlGetActiveSession = (): string => {
  return '/auth/session';
};

export const makeApiUrlActivitiesPendingByProfessionals = (): string => {
  return 'web/director/reports/activities/pending-per-professional';
};

export const makeApiUrlPendingActivitiesByProfessionalsSummary = (): string => {
  return 'web/director/reports/activities/pending-per-professional';
};

export const makeApiUrlPendingActivitiesByProfessionalsExportPdf =
  (): string => {
    return 'web/director/reports/activities/pending-per-professional/export/pdf';
  };

export const makeApiUrlPendingActivitiesByProfessionalsExportExcel =
  (): string => {
    return 'web/director/reports/activities/pending-per-professional/export/excel';
  };

export const makeApiUrlProfessionalsDailyWorkload = (): string => {
  return '/web/director/reports/professionals/daily-workload/crosstable';
};

export const makeApiUrlProfessionalsDailyWorkloadExportExcel = (): string => {
  return '/web/director/reports/professionals/daily-workload/export';
};

export const makeApiUrlExportAccessReportExcel = (): string => {
  return '/web/director/reports/access/export/excel';
};

export const makeApiUrlSuspectedManipulation = (): string => {
  return '/web/director/reports/activities/suspected-manipulation';
};

export const makeApiUrlSuspectedManipulationCount = (): string => {
  return '/web/director/reports/activities/suspected-manipulation/count';
};

export const makeApiUrlSuspectedStudentsRanking = (): string => {
  return '/web/director/reports/activities/suspected-manipulation/students-ranking';
};

export const makeApiUrlExportSuspectedManipulation = (): string => {
  return '/web/director/reports/activities/suspected-manipulation/export';
};

export const makeApiUrlExportSuspectedStudentsRanking = (): string => {
  return '/web/director/reports/activities/suspected-manipulation/students-ranking/export';
};

export const makeApiUrlOrganizations = (): string => {
  return '/organizations';
};

export const makeApiUrlMissedActivitiesJustifications = (): string => {
  return '/reports/activities/lost-activities-justifications';
};

// Reports for Professionals - Performance Report

export const makeApiUrlPerformanceReportForProfessionalsSummary =
  (): string => {
    return '/reports/professionals/performance/summary';
  };

export const makeApiUrlPerformanceReportForProfessionalsTopValidatedActivities =
  (): string => {
    return '/reports/professionals/performance/top-per-validated-activities';
  };

export const makeApiUrlPerformanceReportForProfessionalsEvolution =
  (): string => {
    return '/reports/professionals/performance/validated-activities-evolution';
  };

export const makeApiUrlPerformanceReportForProfessionalsRanking =
  (): string => {
    return '/reports/professionals/performance/ranking';
  };

export const makeApiUrlPerformanceReportForProfessionalsExcel = (): string => {
  return '/reports/professionals/performance/spreadsheet';
};

export const makeApiUrlCancellationReasons = (): string => {
  return '/cancellation-reasons';
};

// reset password
// step 1
export const makeApiUrlResetPasswordSendCode = (): string => {
  return '/auth/password/request-reset';
};

// step 2
export const makeApiUrlResetPasswordValidatedCode = (): string => {
  return '/auth/2fa/validate';
};

// step 3
export const makeApiUrlResetPassword = (): string => {
  return '/auth/password';
};

export const makeApiUrlTceManagement = (): string => {
  return '/tce';
};
